import { WithSnowplow } from '@montugroup/data-collection';
import { jwtDecode } from 'jwt-decode';
import type { FC, PropsWithChildren } from 'react';
import { useLocation } from 'react-router-dom';
import type { TokenUser } from '~/types/Auth';
import { useAuth } from './AuthProvider';

export const SnowplowProvider: FC<PropsWithChildren> = ({ children }) => {
  const location = useLocation();
  const { token } = useAuth();

  const user = token ? jwtDecode<TokenUser>(token) : null;

  const childrenWithSnowplow = WithSnowplow(
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>{children}</>,
    {
      appId: 'montu.supplier-portal',
      trackerName: 'hoc.montu-web/apps/supplier-portal',
      locationOverride: location,
      snowplowEndpointOverride: import.meta.env?.VITE_PUBLIC_SNOWPLOW_URL,
      userId: user?.sub,
      pageViewContext: [],
    },
    true,
  );

  return childrenWithSnowplow;
};
